@if ($configSchema() != null) {
    <div class="form-group mt-4">
        <h5>Configurações do E-Docs</h5>
        <hr class="mt-0 mb-4" />
    </div>

    <div class="form-group mt-4">
        <h6>
            <span featureHint="flowObjectDetails|RegisterProcessLocation" featureHintHAlign="right">Local de Autuação</span>
        </h6>
    </div>

    <edocs-location #edocsLocationRef
                    _organizationLabel="Órgão"
                    _unitLabel="Setor"
                    [_model]="$configSchemaSectionEDocsLocation()"
                    [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                    [_isReadOnlyMode]="$isReadOnlyMode()"
                    [_hideGroup]="true"
                    [_hideComission]="true"
                    (_modelChange)="onUpdateEDocsLocation($event)"
    ></edocs-location>

    <!-- Local de Autuação -->
    <div class="form-group ml-6" featureHint="flowObjectDetails|RegisterProcessLocationSelected" featureHintHAlign="right">
        <label for="processLocationId">Local de Autuação</label>

        <input type="text" class="form-control info-font one-button" id="processLocationId" name="processLocationId" readonly
               placeholder="(nenhum)"
               [ngModel]="$configSchema().taskRegisterProcess.processLocationName"
               [matTooltip]="$configSchema().taskRegisterProcess.processLocationName"
               (change)="processLocationIdChange($event.target.value)"
        >
        <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearProcessLocation()" (keyDown)="clearProcessLocation()"></i>
    </div>

    <div class="form-group mt-4">
        <h6>
            <span featureHint="flowObjectDetails|DocumentClass" featureHintHAlign="right">Classe do Processo</span>
        </h6>
    </div>

    <!-- Classe do Processo -->
    <document-class [_model]="$configSchemaSectionDocumentClass()"
                    [_flowDefinitionOrganizationId]="$flowDefinition().organizationId"
                    [_isReadOnlyMode]="$isReadOnlyMode()"
                    (_modelChange)="onUpdateProcessClass($event)"
    ></document-class>

    <div class="form-group mt-4">
        <h6>
            <span featureHint="flowObjectDetails|RegisterProcessStakeholders" featureHintHAlign="right">Interessados do Processo</span>
        </h6>
    </div>

    <!-- Patriarca -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="patriarchTitle" (click)="togglePatriarcaSection()" (keyDown)="togglePatriarcaSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingPatriarcaSection()"></i>
            <span>Patriarca</span>
        </label>

        @if ($isShowingPatriarcaSection()) {
            <div featureHint="flowObjectDetails|RegisterProcessStakeholdersPatriarch" featureHintHAlign="right">
                <input type="text" class="form-control info-font two-buttons" id="patriarcaDisplay"
                       name="patriarcaDisplay"
                       placeholder="Selecione uma opção"
                       [ngModel]="$patriarcaDisplay()"
                       [matTooltip]="$patriarcaNome()"
                       [matAutocomplete]="patriarcaAutocompleteProcessStakeholders"
                       (ngModelChange)="$patriarcaDisplay.set($event)"
                       (input)="patriarcaDisplayChange()"
                >

                <mat-autocomplete #patriarcaAutocompleteProcessStakeholders="matAutocomplete"
                                  [displayWith]="displayPatriarcaId"
                                  (optionSelected)="patriarcaIdChange($event)"
                >
                    @for (option of $selectablePatriarcas(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.sigla}} - {{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Adicionar" (click)="selectPatriarca()"(keyDown)="selectPatriarca()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearPatriarca()"(keyDown)="clearPatriarca()"></i>
            </div>
        }
    </div>

    <!-- Órgão -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="organizationTitle" (click)="toggleOrganizacaoSection()" (keyDown)="toggleOrganizacaoSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingOrganizacaoSection()"></i>
            <span>Órgão</span>
        </label>

        @if ($isShowingOrganizacaoSection()) {
            <div featureHint="flowObjectDetails|RegisterProcessStakeholdersOrganization" featureHintHAlign="right">
                <input type="text" class="form-control info-font two-buttons" id="organizacaoDisplay"
                       name="organizacaoDisplay"
                       placeholder="Selecione um Patriarca para filtrar os Órgãos disponíveis"
                       [ngModel]="$organizacaoDisplay()"
                       [matTooltip]="$organizacaoNome()"
                       [matAutocomplete]="organizacaoAutocompleteProcessStakeholders"
                       [disabled]="$organizacoes().length == 0"
                       (ngModelChange)="$organizacaoDisplay.set($event)"
                       (input)="organizacaoDisplayChange()"
                >

                <mat-autocomplete #organizacaoAutocompleteProcessStakeholders="matAutocomplete"
                                  [displayWith]="displayOrganizacaoId"
                                  (optionSelected)="organizacaoIdChange($event)"
                >
                    @for (option of $selectableOrganizacoes(); track option) {
                        <mat-option class="uppercase" [value]="option">
                            {{option.sigla}} - {{option.nomeFantasia == '.' ? option.sigla : option.nomeFantasia}}
                        </mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Escolher" (click)="selectOrganizacao()" (keyDown)="selectOrganizacao()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearOrganizacao()" (keyDown)="clearOrganizacao()"></i>
            </div>
        }
    </div>

    <!-- Setor -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="unitTitle" (click)="toggleUnidadeSection()" (keyDown)="toggleUnidadeSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingUnidadeSection()"></i>
            <span>Setor</span>
        </label>

        @if ($isShowingUnidadeSection()) {
            <div featureHint="flowObjectDetails|RegisterProcessStakeholdersUnit" featureHintHAlign="right">
                <input type="text" class="form-control info-font two-buttons" id="unidadeDisplay"
                       name="unidadeDisplay"
                       placeholder="Selecione um Órgão para filtrar os Setores disponíveis"
                       [ngModel]="$unidadeDisplay()"
                       [matTooltip]="$unidadeNome()"
                       [matAutocomplete]="unidadeAutocompleteProcessStakeholders"
                       [disabled]="$unidades().length == 0"
                       (ngModelChange)="$unidadeDisplay.set($event)"
                       (input)="unidadeDisplayChange()"
                >

                <mat-autocomplete #unidadeAutocompleteProcessStakeholders="matAutocomplete"
                                  [displayWith]="displayUnidadeId"
                                  (optionSelected)="unidadeIdChange($event)"
                >
                    @for (option of $selectableUnidades(); track option) {
                        <mat-option class="uppercase" [value]="option">
                            {{option.nomeCurto ? option.nomeCurto + ' - ' : ''}}{{option.nome}}
                        </mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Escolher" (click)="selectUnidade()" (keyDown)="selectUnidade()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearUnidade()" (keyDown)="clearUnidade()"></i>
            </div>
        }
    </div>

    <!-- Grupo de Trabalho -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="groupTitle" (click)="toggleGrupoSection()" (keyDown)="toggleGrupoSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingGrupoSection()"></i>
            <span>Grupo de Trabalho</span>
        </label>

        @if ($isShowingGrupoSection()) {
            <div featureHint="flowObjectDetails|RegisterProcessStakeholdersGroup" featureHintHAlign="right">
                <input type="text" class="form-control info-font two-buttons" id="grupoDisplay"
                       name="grupoDisplay"
                       placeholder="Selecione um Órgão para filtrar os Grupos disponíveis"
                       [ngModel]="$grupoDisplay()"
                       [matTooltip]="$grupoNome()"
                       [matAutocomplete]="grupoAutocompleteProcessStakeholders"
                       [disabled]="$grupos().length == 0"
                       (ngModelChange)="$grupoDisplay.set($event)"
                       (input)="grupoDisplayChange()"
                >

                <mat-autocomplete #grupoAutocompleteProcessStakeholders="matAutocomplete"
                                  [displayWith]="displayGrupoId"
                                  (optionSelected)="grupoIdChange($event)"
                >
                    @for (option of $selectableGrupos(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Escolher" (click)="selectGrupo()" (keyDown)="selectGrupo()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearGrupo()" (keyDown)="clearGrupo()"></i>
            </div>
        }
    </div>

    <!-- Comissão ou Contrato -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="comissionTitle" (click)="toggleComissaoSection()" (keyDown)="toggleComissaoSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingComissaoSection()"></i>
            <span>Comissão ou Contrato</span>
        </label>

        @if ($isShowingComissaoSection()) {
            <div featureHint="flowObjectDetails|RegisterProcessStakeholdersComission" featureHintHAlign="right">
                <input type="text" class="form-control info-font two-buttons" id="comissaoDisplay"
                       name="comissaoDisplay"
                       placeholder="Selecione um Órgão para filtrar as Comissões ou Contratos disponíveis"
                       [ngModel]="$comissaoDisplay()"
                       [matTooltip]="$comissaoNome()"
                       [matAutocomplete]="comissaoAutocompleteProcessStakeholders"
                       [disabled]="$comissoes().length == 0"
                       (ngModelChange)="$comissaoDisplay.set($event)"
                       (input)="comissaoDisplayChange()"
                >

                <mat-autocomplete #comissaoAutocompleteProcessStakeholders="matAutocomplete"
                                  [displayWith]="displayComissaoId"
                                  (optionSelected)="comissaoIdChange($event)"
                >
                    @for (option of $selectableComissoes(); track option) {
                        <mat-option class="uppercase" [value]="option">{{option.nome}}</mat-option>
                    }
                </mat-autocomplete>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Escolher" (click)="selectComissao()" (keyDown)="selectComissao()"></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearComissao()" (keyDown)="clearComissao()"></i>
            </div>
        }
    </div>

    <!-- Servidor -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="publicAgentTitle" (click)="toggleServidorSection()" (keyDown)="toggleServidorSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingServidorSection()"></i>
            <span>Servidor</span>
        </label>
    </div>

    @if ($isShowingServidorSection()) {
    <!-- CPF do Servidor -->
        <div class="form-group process-stakeholders ml-4" featureHint="flowObjectDetails|RegisterProcessStakeholdersPublicAgentCpf" featureHintHAlign="right">
            <label for="servidorCpf">CPF do Servidor</label>

            <input type="text" class="form-control two-buttons" id="servidorCpf" name="servidorCpf"
                   placeholder="Entre com o CPF do servidor para filtrar seus papéis"
                   maxlength="11"
                   pattern="[0-9]{11}"
                   [ngModel]="$servidorCpf()"
                   (change)="$servidorCpf.set($event.target.value)"
                   (keyup.enter)="searchServidorCpf()"
            >

            <i class="fas fa-search action search ml-2" matTooltip="Procurar" (click)="searchServidorCpf()" (keyDown)="searchServidorCpf()"></i>
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearServidorCpf()" (keyDown)="clearServidorCpf()"></i>
        </div>

        <!-- Papéis do Servidor -->
        <div class="form-group process-stakeholders ml-5" featureHint="flowObjectDetails|RegisterProcessStakeholdersPublicAgentRole" featureHintHAlign="right">
            <label for="servidorPapelDisplay">Papéis do Servidor</label>

            <input type="text" class="form-control info-font two-buttons" id="servidorPapelDisplay"
                   name="servidorPapelDisplay"
                   placeholder="Selecione um papel do servidor"
                   [ngModel]="$servidorPapelDisplay()"
                   [matTooltip]="$servidorPapelNome()"
                   [matAutocomplete]="servidorPapelAutocompleteProcessStakeholders"
                   [disabled]="$servidorPapeis().length == 0"
                   (ngModelChange)="$servidorPapelDisplay.set($event)"
                   (input)="servidorPapelDisplayChange()"
            >

            <mat-autocomplete #servidorPapelAutocompleteProcessStakeholders="matAutocomplete"
                              [displayWith]="displayServidorPapelId"
                              (optionSelected)="servidorPapelIdChange($event)"
            >
                @for (option of $selectableServidorPapeis(); track option) {
                    <mat-option [value]="option">
                        <span class="uppercase">
                            {{option.nome}} - {{option.lotacao.nomeCurto}} - {{option.lotacao.organizacao.sigla}} - {{option.lotacao.organizacao.organizacaoPai.sigla}}
                        </span>
                    </mat-option>
                }
            </mat-autocomplete>

            <i class="fas fa-plus-circle action add ml-2" matTooltip="Adicionar" (click)="selectServidorPapel()" (keyDown)="selectServidorPapel()"></i>
            <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearServidorPapel()" (keyDown)="clearServidorPapel()"></i>
        </div>
    }

    <!-- Cidadão -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="citizenTitle" (click)="toggleCidadaoSection()" (keyDown)="toggleCidadaoSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingCidadaoSection()"></i>
            <span>Cidadão</span>
        </label>
    </div>

    @if ($isShowingCidadaoSection()) {
        <!-- Cidadão instanciador -->
        <mat-radio-group class="citizen-stakeholder ml-4" id="citizenStakeholder" name="citizenStakeholder" color="primary"
                         featureHint="flowObjectDetails|RegisterProcessStakeholdersCitizen" featureHintHAlign="right" featureHintShowOn="right"
                         [ngModel]="$isCitizenFlowInstanceOwner()"
                         (ngModelChange)="$isCitizenFlowInstanceOwner.set($event)"
        >
            <mat-radio-button [value]="true">
                Adicionar automaticamente o cidadão instanciador do Fluxo

                @if ($isCitizenFlowInstanceOwner() === true) {
                    <i class="fas fa-plus-circle action add ml-2 float-right" matTooltip="Adicionar"
                       (click)="selectCidadaoFlowInstanceOwner()"
                       (keyDown)="selectCidadaoFlowInstanceOwner()"
                    ></i>
                }
            </mat-radio-button>

            <mat-radio-button [value]="false">
                Adicionar cidadão a partir de campo <b>CPF</b> do Formulário
            </mat-radio-button>
        </mat-radio-group>

        <!-- Campo CPF do Formulário -->
        @if ($isCitizenFlowInstanceOwner() === false) {
            <div class="form-group form-field ml-5" featureHint="flowObjectDetails|RegisterProcessStakeholdersCitizenCpf" featureHintHAlign="right">
                <label for="cidadaoFormField">Campo CPF do Formulário</label>

                <select class="form-control two-buttons" id="cidadaoFormField" name="cidadaoFormField"
                        [ngModel]="$cidadaoFormField()"
                        (change)="$cidadaoFormField.set($event.target.value)"
                >
                    <option value="">Selecione um dos campos do formulário</option>

                    @for (option of $cidadaoFormFieldOptions(); track option) {
                        <option [value]="option.value">{{option.description}}</option>
                    }
                </select>

                <i class="fas fa-plus-circle action add ml-2" matTooltip="Adicionar"
                   [class.disabled]="Utils.isNullOrEmpty($cidadaoFormField())"
                   (click)="selectCidadaoFormField()"
                   (keyDown)="selectCidadaoFormField()"
                ></i>
                <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearCidadaoFormField()" (keyDown)="clearCidadaoFormField()"></i>
            </div>
        }
    }

    <!-- Pessoa Jurídica -->
    <div class="form-group process-stakeholders ml-3px">
        <label class="toggle-section" for="companyTitle" (click)="toggleEmpresaSection()" (keyDown)="toggleEmpresaSection()">
            <i class="fas fa-chevron-circle-right" [class.on]="$isShowingEmpresaSection()"></i>
            <span>Pessoa Jurídica</span>
        </label>
    </div>

    @if ($isShowingEmpresaSection()) {
        <!-- Razão Social -->
        <ng-container>
            <div class="form-group fw-600 mt-2 mb-2 ml-4">
                <span>Razão Social</span>
            </div>

            <!-- Modo da Razão Social -->
            <mat-radio-group class="company-stakeholder ml-5" id="companyNameStakeholder" name="companyNameStakeholder" color="primary"
                             featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyName" featureHintHAlign="right"
                             [ngModel]="$isEmpresaCompanyNameFreeEntry()"
                             (ngModelChange)="$isEmpresaCompanyNameFreeEntry.set($event)"
            >
                <mat-radio-button [value]="true">
                    Entrar livremente com o valor para o campo <b>Razão Social</b>
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Escolher campo do Formulário que fornecerá o valor de <b>Razão Social</b>
                </mat-radio-button>
            </mat-radio-group>

            @if ($isEmpresaCompanyNameFreeEntry() === true) {
                <!-- Entrada Livre -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyNameFree" featureHintHAlign="right"
                >
                    <label for="empresaCompanyName">Entrada Livre</label>

                    <input type="text" class="form-control one-button" maxlength="200" id="empresaCompanyName" name="empresaCompanyName"
                           [ngModel]="$empresaCompanyName()"
                           (change)="clearEmpresaCompanyNameFormField($event.target.value)"
                    >

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaCompanyName()" (keyDown)="clearEmpresaCompanyName()"></i>
                </div>
            }

            @if ($isEmpresaCompanyNameFreeEntry() === false) {
                <!-- Campo do Formulário -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyNameFormField" featureHintHAlign="right"
                >
                    <label class="d-inline-block" for="empresaCompanyNameFormField">Campo do Formulário</label>

                    <select class="form-control one-button" id="empresaCompanyNameFormField" name="empresaCompanyNameFormField"
                            [ngModel]="$empresaCompanyNameFormField()"
                            (change)="clearEmpresaCompanyName($event.target.value)"
                    >
                        <option value="">Selecione um dos campos do formulário</option>

                        @for (option of $empresaCompanyNameFormFieldOptions(); track option) {
                            <option [value]="option.value">{{option.description}}</option>
                        }
                    </select>

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaCompanyNameFormField()" (keyDown)="clearEmpresaCompanyNameFormField()"></i>
                </div>
            }
        </ng-container>

        <!-- CNPJ -->
        <ng-container>
            <div class="form-group fw-600 mt-2 mb-2 ml-4">
                <span>CNPJ</span>
            </div>

            <!-- Modo do CNPJ -->
            <mat-radio-group class="company-stakeholder ml-5" id="cnpjStakeholder" name="cnpjStakeholder" color="primary"
                             featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyCnpj" featureHintHAlign="right"
                             [ngModel]="$isEmpresaCnpjFreeEntry()"
                             (ngModelChange)="$isEmpresaCnpjFreeEntry.set($event)"
            >
                <mat-radio-button [value]="true">
                    Entrar livremente com o valor para o campo <b>CNPJ</b>
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Escolher campo do Formulário que fornecerá o valor de <b>CNPJ</b>
                </mat-radio-button>
            </mat-radio-group>

            @if ($isEmpresaCnpjFreeEntry() === true) {
                <!-- Entrada Livre -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyCnpjFree" featureHintHAlign="right"
                >
                    <label for="empresaCnpj">Entrada Livre</label>

                    <input type="text" class="form-control one-button" maxlength="14" id="empresaCnpj" name="empresaCnpj"
                           pattern="[0-9A-Za-z]{12}[0-9]{2}"
                           [ngModel]="$empresaCnpj()"
                           (change)="clearEmpresaCnpjFormField($event.target.value)"
                    >

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaCnpj()" (keyDown)="clearEmpresaCnpj()"></i>
                </div>
            }

            @if ($isEmpresaCnpjFreeEntry() === false) {
                <!-- Campo do Formulário -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyCnpjFormField" featureHintHAlign="right"
                >
                    <label class="d-inline-block" for="empresaCnpjFormField">Campo do Formulário</label>

                    <select class="form-control one-button" id="empresaCnpjFormField" name="empresaCnpjFormField"
                            [ngModel]="$empresaCnpjFormField()"
                            (change)="clearEmpresaCnpj($event.target.value)"
                    >
                        <option value="">Selecione um dos campos do formulário</option>

                        @for (option of $empresaCnpjFormFieldOptions(); track option) {
                            <option [value]="option.value">{{option.description}}</option>
                        }
                    </select>

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaCnpjFormField()" (keyDown)="clearEmpresaCnpjFormField()"></i>
                </div>
            }
        </ng-container>

        <!-- E-mail -->
        <ng-container>
            <div class="form-group fw-600 mt-2 mb-2 ml-4">
                <span>E-mail</span>
            </div>

            <!-- Modo do E-mail -->
            <mat-radio-group class="company-stakeholder ml-5" id="emailStakeholder" name="emailStakeholder" color="primary"
                             featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyEmail" featureHintHAlign="right"
                             [ngModel]="$isEmpresaEmailFreeEntry()"
                             (ngModelChange)="$isEmpresaEmailFreeEntry.set($event)"
            >
                <mat-radio-button [value]="true">
                    Entrar livremente com o valor para o campo <b>E-mail</b>
                </mat-radio-button>
                <mat-radio-button [value]="false">
                    Escolher campo do Formulário que fornecerá o valor de <b>E-mail</b>
                </mat-radio-button>
            </mat-radio-group>

            @if ($isEmpresaEmailFreeEntry() === true) {
                <!-- Entrada Livre -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyEmailFree" featureHintHAlign="right"
                >
                    <label for="empresaEmail">Entrada Livre</label>

                    <input type="email" class="form-control one-button" id="empresaEmail" name="empresaEmail"
                           [ngModel]="$empresaEmail()"
                           (change)="clearEmpresaEmailFormField($event.target.value)"
                    >

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaEmail()" (keyDown)="clearEmpresaEmail()"></i>
                </div>
            }

            @if ($isEmpresaEmailFreeEntry() === false) {
                <!-- Campo do Formulário -->
                <div class="form-group process-stakeholders ml-6 mb-2"
                     featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyEmailFormField" featureHintHAlign="right"
                >
                    <label class="d-inline-block" for="empresaEmailFormField">Campo do Formulário</label>

                    <select class="form-control one-button" id="empresaEmailFormField" name="empresaEmailFormField"
                            [ngModel]="$empresaEmailFormField()"
                            (change)="clearEmpresaEmail($event.target.value)"
                    >
                        <option value="">Selecione um dos campos do formulário</option>

                        @for (option of $empresaEmailFormFieldOptions(); track option) {
                            <option [value]="option.value">{{option.description}}</option>
                        }
                    </select>

                    <i class="fas fa-times-circle action remove ml-2" matTooltip="Limpar" (click)="clearEmpresaEmailFormField()" (keyDown)="clearEmpresaEmailFormField()"></i>
                </div>
            }
        </ng-container>

        <!-- Adicionar Pessoa Jurídica -->
        <div class="form-group add-company-stakeholder mt-4" featureHint="flowObjectDetails|RegisterProcessStakeholdersCompanyAdd" featureHintHAlign="right">
            <button type="button" class="btn btn-outline-primary"
                    [disabled]="shouldDisableAddCompanyStakeholder()"
                    (click)="addCompanyStakeholder()"
                    (keyDown)="addCompanyStakeholder()"
            >
                <i class="fas fa-arrow-circle-down mr-2"></i>
                <span>Adicionar Pessoa Jurídica</span>
                <i class="fas fa-arrow-circle-down ml-2"></i>
            </button>
        </div>
    }

    <!-- Interessados -->
    <ng-container>
        @if ($configSchema().taskRegisterProcess.stakeholders.length == 0) {
            <div class="stakeholders-container empty mt-4 mb-3 p-2"
                 featureHint="flowObjectDetails|RegisterProcessStakeholdersPanel" featureHintHAlign="right" featureHintShowOn="right"
            >
                <span class="info-font">Nenhum interessado adicionado</span>
            </div>
        } @else {
            <div class="stakeholders-container mt-4 mb-3 p-2"
                 featureHint="flowObjectDetails|RegisterProcessStakeholdersPanel" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
            >
                @for (stakeholder of $configSchema().taskRegisterProcess.stakeholders; track stakeholder; let i = $index) {
                    <div class="stakeholder p-2">
                        @let stakeholders = [StakeholderType.Patriarch, StakeholderType.Organization, StakeholderType.Unit, StakeholderType.Group, StakeholderType.Comission, StakeholderType.Citizen];
                        @if (stakeholders.includes(stakeholder.type)) {
                            <div class="stakeholder-content m-0">
                                <b [class.uppercase]="stakeholder.type != StakeholderType.Citizen">{{stakeholder.name}}</b>
                                <br />
                                <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                            </div>
                        }

                        @if (stakeholder.type == StakeholderType.PublicAgent) {
                            <div class="stakeholder-content m-0">
                                <b class="uppercase">{{stakeholder.name.split(' - ')[0]}}</b>
                                <br />
                                <span class="uppercase">{{stakeholder.name.split(' - ').splice(1).join(' - ')}}</span>
                                <br />
                                <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                            </div>
                        }

                        @if (stakeholder.type == StakeholderType.Company) {
                            <div class="stakeholder-content m-0">
                                <b [class.uppercase]="Utils.isNullOrEmpty(stakeholder.companyNameFormField)">{{stakeholder.companyName}}</b>
                                <br />
                                <span>{{Utils.maskCnpj(stakeholder.cnpj)}} <b>|</b> {{stakeholder.email}}</span>
                                <br />
                                <span>{{StakeholderTypeDescription.get(+stakeholder.type)}}</span>
                            </div>
                        }

                        <i class="fas fa-trash-alt ml-2" matTooltip="Remover interessado" (click)="removeStakeholder(stakeholder)" (keyDown)="removeStakeholder(stakeholder)"></i>

                        @if ([StakeholderType.Citizen, StakeholderType.Company].includes(stakeholder.type)) {
                            <span class="checkbox-group">
                                <mat-checkbox id="mandatoryStakeholder_{{i}}" name="mandatoryStakeholder_{{i}}" color="primary"
                                              [(ngModel)]="stakeholder.isMandatory"
                                >Obrigatório</mat-checkbox>
                            </span>
                        }
                    </div>
                }

                <button type="button" class="btn btn-outline-danger"
                        [disabled]="$isReadOnlyMode()"
                        (click)="removeAllStakeholders()"
                        (keyDown)="removeAllStakeholders()"
                >
                    <i class="fas fa-times-circle mr-1"></i>
                    <span>Remover todos os interessados</span>
                </button>
            </div>
        }
    </ng-container>

    <div class="form-group mt-4">
        <h6>Resumo do Processo</h6>
    </div>

    @if ($isProcessSummaryBootstrapFinished()) {
        <div class="form-group ml-3px"
             featureHint="flowObjectDetails|RegisterProcessSummary" featureHintHAlign="right" featureHintVAlign="top" featureHintShowOn="right"
        >
            <editor name="processSummary" apiKey="no-api-key"
                    [ngModel]="$processSummary()"
                    [init]="tinyMceOptionsProcess"
                    (ngModelChange)="$processSummary.set($event)"
            ></editor>
            <textarea id="tinyMceRegisterProcess" class="d-none"></textarea>
        </div>
    }
}
